'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _infact = require('./infact');

var _supercluster = require('supercluster');

var _supercluster2 = _interopRequireDefault(_supercluster);

var _DefaultClusterMarker = require('./DefaultClusterMarker');

var _DefaultClusterMarker2 = _interopRequireDefault(_DefaultClusterMarker);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var cloneElement = _infact.React.cloneElement;

var iLNG = 0,
    iLAT = 1;

var ensureArray = function () {
    var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return Array.isArray(children) ? children : [children];
};

var Cluster = function (_Component) {
    _inherits(Cluster, _Component);

    function Cluster(props) {
        _classCallCheck(this, Cluster);

        var _this = _possibleConstructorReturn(this, (Cluster.__proto__ || Object.getPrototypeOf(Cluster)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Cluster, [{
        key: 'componentDidMount',
        value: function () {
            this.rebuildData(this.props);
        }
    }, {
        key: 'rebuildData',
        value: function (props) {
            var pointsMap = this.generatePointsMap(props.children);
            var index = this.loadPoints(pointsMap);
            this.setState({
                pointsMap: pointsMap,
                index: index
            });
        }
    }, {
        key: 'generatePointsMap',
        value: function (children) {
            var _this2 = this;

            var childrenArray = ensureArray(children);
            var pointsMap = {};

            childrenArray.forEach(function (child) {
                var key = child.key;

                if (!key) {
                    throw new Error('Markers must have a key property', child);
                }
                if (!child.props.anchor) {
                    throw new Error('Markers must have an anchor property', child);
                }
                pointsMap[key] = {
                    vNode: cloneElement(child, {
                        latLngToPixel: _this2.props.latLngToPixel,
                        pixelToLatLng: _this2.props.pixelToLatLng
                    }),
                    geometry: {
                        coordinates: child.props.anchor
                    },
                    id: key
                };
            });

            return pointsMap;
        }
    }, {
        key: 'loadPoints',
        value: function (pointsMap) {
            var index = (0, _supercluster2.default)({
                radius: this.props.clusterMarkerRadius || 40,
                maxZoom: this.props.maxZoom || 16
            });

            index.load(Object.keys(pointsMap).map(function (id) {
                return pointsMap[id];
            }));
            return index;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function (nextProps) {
            if (nextProps.children !== this.props.children) {
                this.rebuildData(nextProps);
            }
        }
    }, {
        key: 'render',
        value: function () {
            var _this3 = this;

            var _props = this.props,
                latLngToPixel = _props.latLngToPixel,
                mapState = _props.mapState,
                className = _props.className;
            var _mapState$bounds = mapState.bounds,
                ne = _mapState$bounds.ne,
                sw = _mapState$bounds.sw;
            var _ref = [sw[iLNG], sw[iLAT], ne[iLNG], ne[iLAT]],
                westLng = _ref[0],
                southLat = _ref[1],
                eastLng = _ref[2],
                northLat = _ref[3];

            var markersAndClusters = this.state.index && this.state.index.getClusters([westLng, southLat, eastLng, northLat], Math.floor(mapState.zoom));

            var displayElements = (markersAndClusters || []).map(function (markerOrCluster) {
                var displayElement = void 0;
                var isCluster = markerOrCluster && markerOrCluster.properties && markerOrCluster.properties.cluster;
                var pixelOffset = latLngToPixel(markerOrCluster.geometry.coordinates);
                if (isCluster) {
                    var clusterElementKey = markerOrCluster.geometry.coordinates.toString();
                    displayElement = _infact.React.createElement(_DefaultClusterMarker2.default, { key: clusterElementKey,
                        count: markerOrCluster.properties.point_count,
                        pixelOffset: pixelOffset });
                } else {
                    displayElement = cloneElement(_this3.state.pointsMap[markerOrCluster.id].vNode, {
                        left: pixelOffset[0],
                        top: pixelOffset[1]
                    });
                }
                return displayElement;
            });

            return _infact.React.createElement('div', { className: className || '',
                style: { position: 'absolute', height: mapState.height, width: mapState.width } }, displayElements);
        }
    }]);

    return Cluster;
}(_infact.Component);

exports.default = Cluster;